<template>
    <section class="o-wrapper o-wrapper--center o-page-bottom-spacing">
        <div class="c-product-detail-header o-page-row">
            <page-title>{{ productData.BrandName }} {{ productData.Name }}</page-title>
            <span class="u-color-base-medium">model {{ productData.ErpId }}</span>
        </div>
        <div class="c-product-layout o-grid o-grid--half o-gutter-huge o-page-row--large">
            <div>
                <div v-if="Media.length" class="u-pos-relative">
                    <v-carousel :media="Media"></v-carousel>
                </div>
                <img v-else src="@/assets/images/no_image_x300.png"/>
            </div>
            <div>
                <div class="o-page-row--large">
                    <div class="u-flex-set u-flex--align-items-center u-flex--wrap o-spacing-large c-product-prices">
                        <div v-if="hasAccess && !isCustomerHidden && isCustomer">
                            <span class="u-font-tiny u-color-base-base u-color-base-medium">
                                <template v-if="productData.IsSinglePrice">
                                    {{ $t('product.detail.original_price') }}
                                </template>
                                <template v-else>
                                    {{ $t('product.detail.from_price') }}
                                </template>
                            </span> <br>
                            <span class="u-color-success-base u-font-large u-semi-bold">{{ productData.DiscountPrice | currency(customerCurrencySymbol) }}</span>
                        </div>
                        <div v-if="showOriginalPrice">
                            <span class="u-font-tiny u-color-base-base u-color-base-medium">{{ $t('product.detail.retail_price') }}</span> <br>
                            <span class="u-color-success-base u-font-large u-semi-bold">{{ productData.OriginalFromPrice | currency(customerCurrencySymbol) }}</span>
                        </div>
                        <div v-if="hasAccess && !isCustomerHidden && !isMarketing">
                            <svgicon name="check" width=".7em" height=".7em" class="u-svg-color-success-base"></svgicon>
                            <span class="u-font-tiny u-medium">Stock</span>
                        </div>
                    </div>
                    <div v-if="hasAccess && !isCustomerHidden" class="o-page-row">
                        <p class="u-font-tiny u-color-base-medium u-opacity-75" v-if="productData.DiscountPercentage > 0">
                            {{$t('product.detail.article_price')}}: {{ productData.RetailFromPrice | currency(customerCurrencySymbol) }} <br>
                            {{$t('product.detail.your_discount')}}: {{ productData.DiscountPercentage }}%
                        </p>
                    </div>
                    <div v-if="hasAccess && !isMarketing" class="o-page-row">
                        <p><input name="dropshipment" id="dropshipment" type="checkbox" v-model="isDropShipment"/><label for="dropshipment"> {{ $t('customer.checkout.dropshipment.text') }}</label></p>
                    </div>
                    <div class="o-page-row">
                        <tabs :options="{ useUrlFragment: false }">
                            <tab :name="$t('customer.shop.detail.product_description')">
                                <p>{{ productData.Description}}</p>
                            </tab>
                            <tab :name="$t('customer.shop.detail.specifications')">
                                <template v-for="property in ProductProperties">
                                    {{ property.Name }} : {{ property.Value }} <br/>
                                </template>
                            </tab>
                            <tab v-if="hasAccess" :name="$t('customer.shop.detail.downloads')">
                                <button @click="sendDownloads('sheets', 'high')" class="c-button c-button--alpha">{{ $t('customer.shop.detail.download_sheet') }}</button><br/><br/>
                                <button @click="sendDownloads('images', 'low')" class="c-button c-button--alpha">{{ $t('customer.shop.detail.download_images_low_resolution') }}</button><br/><br/>
                                <button @click="sendDownloads('images', 'high')" class="c-button c-button--alpha">{{ $t('customer.shop.detail.download_images_high_resolution') }}</button>
                            </tab>
                            <tab v-if="productData.SizeCharts && productData.SizeCharts.length > 0" :name="$t('customer.shop.detail.size_charts')">
                                <template v-for="sizeChart in productData.SizeCharts">
                                    <h3>{{ sizeChart.Name }}</h3>
                                    <table class="c-size-table u-fullwidth u-font-small">
                                        <tr v-for="row in sizeChart.Rows">
                                            <td v-for="col in sizeChart.Columns">
                                                <div>
                                                    {{ sizeChart.Chart[row-1][col-1] }}
                                                </div>
                                            </td>
                                        </tr>
                                    </table>
                                </template>
                            </tab>
                        </tabs>
                    </div>
                </div>

            </div>
        </div>
        <section v-if="hasAccess">
            <h2 class="u-h3 u-text-align-center">{{ $t('global.order') }}</h2>
            <v-product-line v-if="productData.Products" v-for="product in productData.Products" :product="product" :key="product.Id"></v-product-line>
            <button v-if="productData && !isMarketing" :disabled="!isValid" @click.stop="buyProducts" class="u-pull-right c-button c-button--alpha">{{ $t('global.add_to_cart') }}</button>

            <v-modal ref="modal">
                <slot slot="title">{{ $t('customer.basket.added_to_basket')}}</slot>
                <div v-if="basketProducts" class="o-wrapper o-wrapper--center">
                    <form action="" class="c-form c-form--horizontal">
                        <div class="u-max-700 c-form-row">
                            <div>
                                <v-products-table :products="basketProducts.Details"></v-products-table>
                            </div>
                            <div v-if="basketProducts.RemainingForFreeDelivery > 0 && !isDropShipment" class="u-color-error-base">{{ $t('customer.basket.remaining_for_free_delivery', { remaining: getRemaining(basketProducts.RemainingForFreeDelivery) }) }}</div>

                            <div class=u-margin-bottom-large v-if="basketProducts.UpsellingProducts.length">
                                <br/>
                                <hr/>

                                <h5>{{ $t('customer.basket.upselling')}}</h5>
                                <div class="u-margin-bottom-large c-shop-overview">
                                    <v-upselling-thumb v-for="upselling in basketProducts.UpsellingProducts" :product="upselling" :key="upselling.ProductId"></v-upselling-thumb>
                                </div>
                            </div>
                            <br/>
                            <div class="u-text-align-center">
                                <button @click.stop="continueShopping" class="c-button c-button--outline u-margin-right-small">{{$t('customer.shop.detail.continue_shopping')}}</button>
                                <button v-if="!isMarketing" @click.stop="proceedToBasket" class="c-button c-button--alpha">{{$t('customer.shop.detail.order')}}</button>
                            </div>
                        </div>
                    </form>
                </div>
            </v-modal>

        </section>
        <section v-else>
            <h2 class="u-h3 u-text-align-center">{{ $t('customer.shop.detail.product_in_your_assortment') }}</h2>
            <p class="u-text-align-center">{{ $t('customer.shop.detail.contact_to_request_product') }}</p>
            <div class="u-text-align-center">
                <button @click.stop="proceedToContact" class="c-button c-button--alpha">{{ $t('customer.shop.detail.request_product') }}</button>
            </div>
        </section>

    </section>
</template>

<script>
    import Vue from 'vue'
    import VModal from '@/components/modal/Modal'
    import PageTitle from '@/components/common/PageTitle';
    import VSelect from '@/components/form/Select'
    import VInput from '@/components/form/Input'
    import VCheckbox from '@/components/form/Checkbox'
    import VCarousel from '@/components/carousel/Carousel'
    import VProductLine from '@/components/shop/ProductLine'
    import VProduct from '@/components/basket/Product'
    import VProductsTable from '@/components/basket/ProductsTable'
    import VUpsellingThumb from '@/components/shop/UpsellingThumb'

    import {mapGetters} from 'vuex'

    export default {
        props: {},
        components: {
            PageTitle,
            VSelect,
            VInput,
            VCheckbox,
            VCarousel,
            VProductLine,
            VModal,
            VProduct,
            VProductsTable,
            VUpsellingThumb
        },
        data() {
            return {
                isDropShipment: false,
                productData: Object,
                productAmount: 1,
                selectedProduct: {
                    ProductId: Number,
                    ProductGroupId: Number,
                    Amount: Number
                },
                basketProducts: null
            }
        },
        created(){
            this.initialDatafetch();
        },
        watch: {
            "$route.params"() {
                this.initialDatafetch();
            }
        },
        computed:{
            ...mapGetters({
                basketData: 'getBasket'
            }),
            Media() {
                let output = [];

                if(this.productData.Images && this.productData.Images.length > 0) {
                    this.productData.Images.forEach(image => {
                        output.push({
                            type: 'image',
                            src: image.replace('[WIDTH]', 900).replace('[HEIGHT]', 900),
                            w: 900,
                            h: 900
                        })
                    });
                }

                if(this.productData.LinkedVideos && this.productData.LinkedVideos.length > 0){
                    this.productData.LinkedVideos.forEach(video => {
                        output.push({
                            type: 'video',
                            src: video
                        })
                    });
                }

                return output
            },
            ProductProperties(){
                let properties = [];

                if(this.productData && this.productData.Properties){
                    this.productData.Properties.forEach(property => {
                        if(property.Values.length > 0 && property.Values[0].length > 0)
                        {
                            properties.push({ Name: property.Label, Value: property.Values[0] });
                        }
                    });
                }

                return properties;
            },
            isValid() {
                let valid = true;

                if (this.productData && this.productData.Products && this.productData.Products.length > 0) {
                    this.productData.Products.forEach(product => {
                        product.Variants.forEach(variant => {
                            if(variant.Amount && variant.Amount > 0) {
                                if(variant.StockStatus == 'NO') {
                                    valid = false;
                                } else if((variant.StockStatus == 'ZVS' || variant.StockStatus == 'ZVS2') && variant.Amount > variant.Stock) {
                                    valid = false;
                                }
                            }
                        })
                    });
                }

                return valid;
            },
            isCustomerHidden() {
              return this.$store.getters.isCustomerHidden;
            },
            isCustomer() {
                return this.$store.getters.isCustomer;
            },
            isPersoneel() {
                return this.$store.getters.isPersoneel;
            },
            isMarketing() {
                return this.$store.getters.isMarketing;
            },
            customerCurrencySymbol() {
                return this.$store.getters.userInfo.customerCurrencySymbol;
            },
            hasAccess() {
                return this.productData.CustomerHasAccess && this.productData.RetailFromPrice >= 0
            },
            showOriginalPrice(){
                return this.productData.OriginalFromPrice >= 0;
            }
        },
        methods: {
            initialDatafetch() {
                if (this.$attrs.id != null){
                    this.dispatchProductData();
                }
            },
            dispatchProductData() {
                let color = this.$route.query.color != null ? this.$route.query.color : "";
                let stockOnly = this.$route.query.stockOnly != null ? this.$route.query.stockOnly: "";
                this.$store.dispatch(('getProductById').toString(), {
                    id : this.$attrs.id,
                    color: color,
                    stockOnly: stockOnly
                }).then(() => {
                    this.productData = this.$store.getters['Product'];
                    this.addBasketAmounts();
                });
            },
            addBasketAmounts() {
                if(this.basketData){
                    this.productData.Products.forEach(product => {
                        var basketProduct = this.basketData.Products.filter(x => x.ProductId === product.Id);
                        if(basketProduct && basketProduct.length > 0) {
                            // 2D-array for variants (due to pants sizes, nested loop)
                            product.Variants.forEach(variantline => {
                                variantline.forEach(variant => {
                                    var basketVariant = basketProduct[0].Variants.filter(x => x.ProductSku == variant.Sku);
                                    if(basketVariant && basketVariant.length > 0) {
                                        variant.BasketAmount = basketVariant[0].ProductAmount;
                                    }
                                })
                            });
                        }
                    });
                }
            },
            buyProducts() {
                let selectedProducts = this.getSelectedProducts();

                if (selectedProducts.length === 0) {
                    this.$notify({
                        group: 'global',
                        title: "No products added to cart! Please add at least 1 product.",
                        type: 'info',
                        duration: 4000
                    });
                    return;
                }

                this.$store.dispatch("addProductsToBasket",{
                    products: selectedProducts,
                    isDropshipment: this.isDropShipment
                }).then(result => {

                    // Get Basket from server
                    this.$store.dispatch("getBasket");

                    if (result.Errors && result.Errors.length > 0) {
                        result.Errors.forEach(e => {
                            this.$notify({
                                group: 'global',
                                title: e,
                                type: 'error',
                                duration: 4000
                            });
                        });
                    } else {
                        this.$refs.modal.openDialog();
                        this.basketProducts = result;

                        this.$notify({
                            group: 'global',
                            title: this.$t('customer.shop.detail.productsAdded'),
                            type: 'success',
                            duration: 4000
                        });
                    }
                });
            },
            getSelectedProducts() {
                let products = [];

                // Products
                this.productData.Products.forEach(product => {

                    // Variants
                    product.Variants.forEach(variantline => {

                        variantline.forEach(variant => {
                                if (variant && variant.Amount > 0){
                                    products.push({ amount: variant.Amount, productVariantId: variant.Id, productId: product.Id });
                                    variant.Amount = null;
                                }
                            });

                        // // Pants sizes
                        // if (product.SizeChartId === 2) {

                        //     // Variantline
                        //     variantline.forEach(variant => {
                        //         if (variant.Amount > 0){
                        //             products.push({ amount: variant.Amount, productVariantId: variant.Id, productId: product.Id });
                        //             variant.Amount = null;
                        //         }
                        //     });
                        // }
                        // // Default sizes
                        // else {

                        //     // Variantline
                        //     if (variantline.Amount > 0) {
                        //         products.push({ amount: variantline.Amount, productVariantId: variantline.Id, productId: product.Id });
                        //         variantline.Amount = null;
                        //     }
                        // }

                    });
                });

                return products;
            },
            sendDownloads(type, resolution) {
                this.$store.dispatch('sendDownloads', {
                    type: type,
                    resolution: resolution,
                    body: this.productData.Products.map(x => x.Id)
                }).then((response) => {
                    window.location = response.Url;
                });
            },
            continueShopping() {
                this.$refs.modal.closeDialog();
                this.$router.push({ name: 'ShopOverview' });
            },
            proceedToBasket() {
                this.$refs.modal.closeDialog();
                this.$router.push({ name: 'BasketOverview' });
            },
            proceedToContact() {
                this.$store.dispatch('setProductAccessRequested', this.productData.BrandName + ' ' + this.productData.Name);
                this.$router.push({ name: 'Contact', params: { Brand: this.productData.Brand }});
            },
            getRemaining(remainingPrice){
                return this.$options.filters.currency(remainingPrice, this.customerCurrencySymbol);
            },
        }
    }
</script>

<style lang="scss" scoped>
    @import "~@/assets/scss/private";

    .c-product-layout {
        @include up($mobile-landscape) {
            > * {
                &:not(:last-child) {
                    position: relative;

                    &:after {
                        content: '';
                        height: em(90px);
                        width: 3px;
                        background-color: $color-alpha;
                        position: absolute;
                        right: -2.5px;
                        top: 0;
                    }
                }
            }

            &.o-gutter-huge {
                > * {
                    &:not(:last-child) {
                        &:after {
                            right: em(-$global-spacing-unit-huge/2);
                        }
                    }
                }
            }
        }
    }

    .c-product-detail__block {
        &-title {
            border-bottom: 1px solid $color-neutral;
            padding: em($global-spacing-unit-small);
            font-weight: $semi-bold;
            margin-bottom: em($global-spacing-unit-small);
        }

        &-content {
            padding: 0 em($global-spacing-unit-small);
        }
    }

    .c-shop-overview {
        margin-bottom: 80px;
        display: flex;
        flex-wrap: wrap;
        > * {
            flex: 0 0 (100%/4);
        }
        @supports (display: grid) {
            display: grid;
            grid-gap: 30px;
            grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
        }
    }

    .size_chart {
        width:100%;
    }

    .size_chart tr td {
        padding: 3px;
        border: 1px solid black;
        height: 28px;
    }

    .size_chart tr td > div{
        width: 100%;
        height:100%;
        overflow: hidden;
    }
</style>

<style lang="scss">
    @import "~@/assets/scss/private";

    .c-product-detail-header {
        display: flex;
        flex-direction: column;
        align-items: center;

        .c-page-title {
            margin-bottom: 0 !important;
        }
    }

    .c-product-layout.o-grid--half > * {
        @include down($desktop) {
            flex: 0 0 100%;
            max-width: 100%;
        }
    }

</style>



// WEBPACK FOOTER //
// src/views/customer/shop/Detail.vue